import { API_URL } from "../../../Config/api";
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Backoffice/Sidebar";
import Title from "../../../Components/Backoffice/Title";
import Header from "../../../Components/Backoffice/Header";
import Footer from "../../../Components/Backoffice/Footer";
import Card from "../../../Components/Backoffice/Card";
import { Col, Row, Space, Table, Tabs } from "antd";

import ExportButton from "../../../Components/Backoffice/ExportButton";
import Search from "antd/es/input/Search";

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: var(--sidebar-width, 7.083vw) 1fr;
  transition: grid-template-columns 0.3s ease;
  min-height: 100vh;

  .export-registos .ant-btn,
  .export-registos .ant-space-item,
  .export-registos.ant-btn-primary.cta {
    min-height: 45px !important;
  }

  .ant-space-item {
    height: -webkit-fill-available !important;
  }
`;

const ContentHeader = styled.div`
  align-items: center;
  display: grid;
  gap: 22px;
  grid-template-columns: 1fr auto;
`;

const Content = styled.div`
  padding: 1.771vw;
`;

const CardContent = styled.div`
  margin: 0;
  position: relative;

  input,
  button {
    min-height: 46px;
  }

  table th {
    color: #809fb8 !important;
  }

  table td {
    color: #494d7d;
  }

  li.ant-pagination-item {
    border: 1px solid #d9e1e7cc;
  }

  li.ant-pagination-item.ant-pagination-item-active {
    background-color: #8688a8;
    border-color: #8688a8;
    color: #ffffff;
  }
`;

const formatData = (value) => {
  if (!value) return "-";
  const data = new Date(value);
  if (isNaN(data.getTime())) return "-";
  const dia = data.toLocaleDateString();
  const hora = data.getHours();
  const minutos = data.getMinutes();
  return `${dia} ${hora}h${minutos}m`;
};

const formatValor = (valor) => (Number(valor) ? valor + " €" : "N/A");

export default function DashboardRegistos() {
  document.title = "SPAP - Registos";

  const [inscricoesEventos, setInscricoesEventos] = useState([]);
  const [pagamentosQuotas, setPagamentosQuotas] = useState([]);
  const [registosPlataforma, setRegistosPlataforma] = useState([]);

  const [searchEventos, setSearchEventos] = useState("");
  const [searchQuotas, setSearchQuotas] = useState("");
  const [searchUsers, setSearchUsers] = useState("");

  useEffect(() => {
    const session_storage = JSON.parse(localStorage.getItem("session_data"));

    fetch(`${API_URL}/admin/registos`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage?.token,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar registos");
        }
        return response.json();
      })
      .then((data) => {
        setInscricoesEventos(data.inscricoesEventos ?? []);
        setPagamentosQuotas(data.pagamentosQuotas ?? []);
        setRegistosPlataforma(data.registosPlataforma ?? []);
      })
      .catch((error) => console.error(error));
  }, []);

  const nomeUtilizador = (row) =>
    `${row.user_name ?? ""} ${row.user_apelido ?? ""}`.trim();

  const eventosColumns = [
    { title: "Utilizador", dataIndex: "userDisplay" },
    { title: "Email", dataIndex: "user_email" },
    { title: "Evento", dataIndex: "evento" },
    { title: "Data de inscrição", dataIndex: "dataDisplay" },
    { title: "Valor", dataIndex: "valorDisplay" },
    { title: "Tipo de pagamento", dataIndex: "payment_type" },
    { title: "Estado", dataIndex: "status" },
  ];

  const eventosData = inscricoesEventos
    .map((row, i) => ({
      key: i,
      ...row,
      userDisplay: nomeUtilizador(row),
      dataDisplay: formatData(row.created_at),
      valorDisplay: formatValor(row.price),
    }))
    .filter((row) => {
      const term = searchEventos.toLowerCase();
      return (
        row.userDisplay.toLowerCase().includes(term) ||
        row.user_email?.toLowerCase().includes(term) ||
        row.evento?.toLowerCase().includes(term)
      );
    });

  const quotasColumns = [
    { title: "Utilizador", dataIndex: "userDisplay" },
    { title: "Email", dataIndex: "user_email" },
    { title: "Tipo", dataIndex: "tipo" },
    { title: "Ano", dataIndex: "ano" },
    { title: "Valor", dataIndex: "valorDisplay" },
    { title: "Estado", dataIndex: "status" },
    { title: "Data de pagamento", dataIndex: "dataDisplay" },
  ];

  const quotasData = pagamentosQuotas
    .map((row, i) => ({
      key: i,
      ...row,
      userDisplay: nomeUtilizador(row),
      dataDisplay: formatData(row.payment_date || row.payment_valid_date),
      valorDisplay: formatValor(row.valor),
    }))
    .filter((row) => {
      const term = searchQuotas.toLowerCase();
      return (
        row.userDisplay.toLowerCase().includes(term) ||
        row.user_email?.toLowerCase().includes(term) ||
        String(row.tipo).toLowerCase().includes(term) ||
        String(row.ano).toLowerCase().includes(term)
      );
    });

  const usersColumns = [
    { title: "Nome", dataIndex: "nomeDisplay" },
    { title: "Email", dataIndex: "email" },
    { title: "Nº sócio", dataIndex: "numero_socio" },
    { title: "Tipo de sócio", dataIndex: "tipo_socio" },
    { title: "Estado", dataIndex: "status" },
    { title: "Data de registo", dataIndex: "dataDisplay" },
  ];

  const usersData = registosPlataforma
    .map((row, i) => ({
      key: i,
      ...row,
      nomeDisplay: `${row.name ?? ""} ${row.apelido ?? ""}`.trim(),
      dataDisplay: formatData(row.created_at),
    }))
    .filter((row) => {
      const term = searchUsers.toLowerCase();
      return (
        row.nomeDisplay.toLowerCase().includes(term) ||
        row.email?.toLowerCase().includes(term) ||
        String(row.numero_socio).toLowerCase().includes(term)
      );
    });

  const tablePagination = {
    showSizeChanger: true,
    locale: { items_per_page: " / página" },
    pageSizeOptions: ["10", "25", "50"],
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };

  const tabItems = [
    {
      key: "1",
      label: "Inscrições em Eventos",
      children: (
        <>
          <ContentHeader className="mb-10">
            <div />
            <Col align="right" span={24}>
              <Space size={28} className="export-registos">
                <Search
                  className="back-input"
                  style={{ width: "500px" }}
                  placeholder="Procurar por utilizador, email ou evento..."
                  onSearch={(e) => setSearchEventos(e.target.value)}
                  onChange={(e) => setSearchEventos(e.target.value)}
                  enterButton
                />
                <ExportButton
                  data={eventosData}
                  columns={eventosColumns}
                  fileName="inscricoes_eventos"
                />
              </Space>
            </Col>
          </ContentHeader>
          <CardContent>
            <Table
              columns={eventosColumns}
              dataSource={eventosData}
              pagination={tablePagination}
            />
          </CardContent>
        </>
      ),
    },
    {
      key: "2",
      label: "Pagamentos de Quotas",
      children: (
        <>
          <ContentHeader className="mb-10">
            <div />
            <Col align="right" span={24}>
              <Space size={28} className="export-registos">
                <Search
                  className="back-input"
                  style={{ width: "500px" }}
                  placeholder="Procurar por utilizador, email, tipo ou ano..."
                  onSearch={(e) => setSearchQuotas(e.target.value)}
                  onChange={(e) => setSearchQuotas(e.target.value)}
                  enterButton
                />
                <ExportButton
                  data={quotasData}
                  columns={quotasColumns}
                  fileName="pagamentos_quotas"
                />
              </Space>
            </Col>
          </ContentHeader>
          <CardContent>
            <Table
              columns={quotasColumns}
              dataSource={quotasData}
              pagination={tablePagination}
            />
          </CardContent>
        </>
      ),
    },
    {
      key: "3",
      label: "Registos na Plataforma",
      children: (
        <>
          <ContentHeader className="mb-10">
            <div />
            <Col align="right" span={24}>
              <Space size={28} className="export-registos">
                <Search
                  className="back-input"
                  style={{ width: "500px" }}
                  placeholder="Procurar por nome, email ou nº de sócio..."
                  onSearch={(e) => setSearchUsers(e.target.value)}
                  onChange={(e) => setSearchUsers(e.target.value)}
                  enterButton
                />
                <ExportButton
                  data={usersData}
                  columns={usersColumns}
                  fileName="registos_plataforma"
                />
              </Space>
            </Col>
          </ContentHeader>
          <CardContent>
            <Table
              columns={usersColumns}
              dataSource={usersData}
              pagination={tablePagination}
            />
          </CardContent>
        </>
      ),
    },
  ];

  return (
    <Wrapper>
      <div>
        <Sidebar />
      </div>
      <Content>
        <Header />
        <Row className="mb-10">
          <Title>Registos</Title>
        </Row>
        <Card className="table-section">
          <Tabs defaultActiveKey="1" items={tabItems} />
        </Card>
        <Footer />
      </Content>
    </Wrapper>
  );
}
